import { DESIGN_DRAFT_KEY, PREFERENCES_KEY, readScoped, removeScoped, writeScoped } from './userScopedStorage'
import { clearDesignHandoff } from './designHandoff'

export const DEFAULT_PREFERENCES = {
  design: {
    defaultType: 'T-Shirt',
    defaultMaterial: 'Cotton',
    defaultQuality: 'premium',
    presentationMode: 'product',
    modelGender: 'woman',
    autoSaveDesigns: true,
    autoSaveStudio: true
  },
  notifications: {
    designComplete: true,
    manufacturingUpdates: true,
    orderShipped: true,
    communityActivity: false,
    marketingEmails: false,
    productUpdates: true,
    assistantTips: true
  },
  privacy: {
    shareAnonymousAnalytics: true,
    showNameInCommunity: true,
    allowDesignRemix: true
  },
  display: {
    theme: 'dark',
    units: 'imperial',
    compactSidebar: false,
    reducedMotion: false
  },
  assistant: {
    proactiveSuggestions: true,
    rememberConversationContext: true,
    includeMeasurementsInPrompts: true
  }
}

export function mergePreferences(stored = {}) {
  return {
    design: { ...DEFAULT_PREFERENCES.design, ...stored.design },
    notifications: { ...DEFAULT_PREFERENCES.notifications, ...stored.notifications },
    privacy: { ...DEFAULT_PREFERENCES.privacy, ...stored.privacy },
    display: { ...DEFAULT_PREFERENCES.display, ...stored.display },
    assistant: { ...DEFAULT_PREFERENCES.assistant, ...stored.assistant }
  }
}

export function loadLocalPreferences(uid) {
  const stored = readScoped(PREFERENCES_KEY, uid)
  return stored ? mergePreferences(stored) : { ...DEFAULT_PREFERENCES }
}

export function saveLocalPreferences(prefs, uid) {
  writeScoped(PREFERENCES_KEY, uid, prefs)
}

export function clearLocalDrafts(uid) {
  removeScoped(DESIGN_DRAFT_KEY, uid)
  clearDesignHandoff()
}
